module.exports = __webpack_public_path__ + "static/media/how-we-work.88c776d4.jpg";